import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';

export default function useUpdateTaskBucket() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.DRAG_AND_DROP_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {},
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
        queryClient.invalidateQueries('get-all-buckets');
      },
    }
  );
}
